import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const variants = cva(
  'rounded-full shrink-0 inline-flex items-center justify-center transition-colors ring-offset-background transition-colors duration-300 ease-in-out focus:outline-none focus-visible:ring-0 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      size: {
        default: 'h-8 w-8',
        large: 'h-10 w-10',
      },
      theme: {
        dark: '',
        light: '',
      },
      style: {
        default:
          'border border-gray-200 bg-white text-gray-400 hover:border-gray-300 hover:text-black dark:bg-black dark:border-zinc-700 dark:hover:border-zinc-600 dark:text-zinc-400 dark:hover:text-white',
        invert:
          'border border-white/20 hover:border-primary-500/20 hover:bg-primary-500/10 hover:text-primary-500',
        active:
          'border border-gray-300 bg-gray-50 text-black dark:bg-white/5 dark:border-zinc-700 dark:text-white',
        activePrimary: 'border border-primary-500/20 bg-primary-500/10 text-primary-500',
        glass:
          'border text-white bg-white/5 backdrop-blur-md border-white/15 hover:border-white/25',
        input:
          'border bg-gray-50 border-gray-200 hover:border-gray-300 dark:border-white/20 dark:bg-black dark:text-white dark:hover:border-primary-500/20 dark:hover:bg-primary-500/10 dark:hover:text-primary-500',
      },
    },
    defaultVariants: {
      size: 'default',
      style: 'default',
    },
    compoundVariants: [
      {
        style: 'default',
        theme: 'dark',
        class: 'bg-black border-white/15 hover:border-white/25',
      },
    ],
  },
)

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof variants> & {
    size?: 'default' | 'large'
    theme?: 'dark' | 'light'
    style?: 'default' | 'invert' | 'active' | 'activePrimary' | 'glass' | 'input'
  }

export default function Button({ size, theme, style, onClick, className, ...props }: ButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(variants({ size, theme, style, className }))}
      {...props}
    >
      {props.children}
    </button>
  )
}
